// Fire an image loaded event when all images have loaded on the page
const imgs = document.images;
const len = imgs.length;
let counter = 0;

function incrementCounter() {
  counter += 1;

  if (counter === len) {
    const imagesLoaded = new Event('imagesLoaded');
    window.dispatchEvent(imagesLoaded);
  }
}

[].forEach.call(imgs, img => {
  if (img.complete) incrementCounter();
  else img.addEventListener('load', incrementCounter, false);
});
